import {
    apiRequest
} from '../api.js'



/*用户登录*/
export function userLogin(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/PaAdmin/userLogin'
    apiRequest(config)
}

/*退出登录*/
export function loginout(config) {
    config.method = 'post'
    config.url = '/project/PaAdmin/logout'
    apiRequest(config)
}

/*修改密码*/
export function changePassword(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/PaAdmin/changePwd'
    apiRequest(config)
}

/*找回密码*/
export function forgetPassword(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/PaAdmin/forgetPassword'
    apiRequest(config)
}

/*发送验证码*/
export function sendSms(config) {
    config.method = 'post'
    config.formData = true
    config.url = '/project/PaAdmin/sendSms'
    apiRequest(config)
}



